const ALERT_SHOW = 'alerts/ALERT_SHOW';
const ALERT_DISMISS = 'alerts/ALERT_DISMISS';
const ALERT_DISMISS_BY_HEADER = 'alerts/ALERT_DISMISS_BY_HEADER';

export default {
  ALERT_SHOW,
  ALERT_DISMISS,
  ALERT_DISMISS_BY_HEADER,
};
